import React, { useEffect, useRef, useState } from "react";
import "./WhyChooseUs.css";
import wc1 from '../assets/wc1.jpg';
import wc2 from '../assets/wc2.jpg';
import wc3 from '../assets/wc3.jpg';
import wc4 from '../assets/wc4.jpg';
import wc5 from '../assets/wc5.jpg';
import wc6 from '../assets/wc6.jpg';

const items = [
  { icon: "🛠️", text: "Complete HVAC Project Expertise",image: wc1, },
  { icon: "👨‍🔧", text: "30+ Technicians With 10+ Years Experience",image: wc2, },
  { icon: "🏢", text: "Authorized Partner for Samsung & Carrier",image: wc3, },
  { icon: "⚙️", text: "Commercial & High-Value Project Experience",image: wc4, },
  { icon: "🤝", text: "In-House Duct Manufacturing Unit",image: wc5, },
  { icon: "📊", text: "Strong Team & Trusted Brand Partnerships",image: wc6, },
];

export default function WhyChooseUs() {
  const trackRef = useRef(null);
  const containerRef = useRef(null);

  const [itemsPerView, setItemsPerView] = useState(4); // default
  const [itemWidth, setItemWidth] = useState(0);
  const [index, setIndex] = useState(0); // left-most visible item index

  // compute itemsPerView based on window width
  useEffect(() => {
  const compute = () => {
    const w = window.innerWidth;
    if (w <= 400) setItemsPerView(1);      // only 1 card for very small devices
    else if (w <= 600) setItemsPerView(2);
    else if (w <= 992) setItemsPerView(3);
    else setItemsPerView(4);
  };
  compute();
  window.addEventListener("resize", compute);
  return () => window.removeEventListener("resize", compute);
}, []);

  // compute itemWidth whenever container size or itemsPerView changes
  useEffect(() => {
    const updateWidths = () => {
      const container = containerRef.current;
      if (!container) return;
      // gap chosen in CSS is 24px between cards; we'll subtract total gaps
      const gapPx = 24; // should match CSS .why-track gap (or margins)
      const visibleGapTotal = gapPx * (itemsPerView - 1);
      // available width for cards = container width - total gaps
      const avail = container.clientWidth - visibleGapTotal;
      const w = Math.floor(avail / itemsPerView);
      setItemWidth(w);
      // ensure index stays within bounds after resize
      const maxIndex = Math.max(0, items.length - itemsPerView);
      setIndex((prev) => Math.min(prev, maxIndex));
    };

    updateWidths();
    // ResizeObserver for better responsiveness
    let ro = null;
    if (containerRef.current && window.ResizeObserver) {
      ro = new ResizeObserver(updateWidths);
      ro.observe(containerRef.current);
    }
    window.addEventListener("resize", updateWidths);
    return () => {
      window.removeEventListener("resize", updateWidths);
      if (ro) ro.disconnect();
    };
  }, [itemsPerView]);

  const maxIndex = Math.max(0, items.length - itemsPerView);

  const goNext = () => {
    setIndex((prev) => Math.min(prev + 1, maxIndex));
  };

  const goPrev = () => {
    setIndex((prev) => Math.max(prev - 1, 0));
  };

  return (
    <section
      className="why-section"
    >
      <div className="why-inner">
        <div className="why-header">
          <h2 className="why-title">Why Choose Us</h2>

          <div className="why-arrows">
            <button
              className="arrow-btn"
              onClick={goPrev}
              aria-label="Previous"
              disabled={index === 0}
            >
              ‹
            </button>
            <button
              className="arrow-btn"
              onClick={goNext}
              aria-label="Next"
              disabled={index === maxIndex}
            >
              ›
            </button>
          </div>
        </div>

        <div className="why-slider" ref={containerRef}>
  <div
    className="why-track"
    ref={trackRef}
    style={{
      transform: `translateX(-${index * (itemWidth + 24)}px)`,
      transition: "transform 450ms ease",
      display: "flex",
      gap: "24px",
    }}
  >
    {items.map((it, i) => (
      <div
        key={i}
        className="why-card-container"
        style={{
          width: itemWidth ? `${itemWidth}px` : "260px",
          minWidth: itemWidth ? `${itemWidth}px` : "260px",
        }}
      >
        {/* Image */}
        <div
          className="why-card-image"
          style={{ backgroundImage: `url(${it.image})` }}
        ></div>

        {/* Icon always above overlay */}
        <div className="why-icon-small">{it.icon}</div>

        {/* Dark overlay with description */}
        <div className="why-overlay">
          <div className="why-description">{it.description}</div>
        </div>

        {/* Service name under image, moves to center on hover */}
        <div className="why-card-service">{it.text}</div>
      </div>
    ))}
  </div>
</div>

      </div>
    </section>
  );
}
